import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

import { isAlternateLocale } from "@/features/blog/locales";

export const Route = createFileRoute("/_landing/$locale")({
  beforeLoad: ({ params }) => {
    if (!isAlternateLocale(params.locale)) throw notFound();
  },
  component: Outlet,
});
